import { createUseStyles } from "react-jss";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useStyles = createUseStyles((_) => ({
  popinContainer: {
    position: "relative",
    "& .MuiDrawer-paper": {
      overflow: "unset",
    },
  },
  popin: {
    minWidth: 500,
    padding: "41px 55.5px",
    overflow: "unset",
    overflowY: "auto",
    "& .react-datepicker-popper": {
      zIndex: 100,
    },
  },
  iconClose: {
    position: "absolute !important",
    top: 18,
    left: -23,
    minWidth: "46px !important",
    width: 46,
    height: 46,
    borderRadius: "23px !important",
    opacity: 1,
    border: "1px solid #DFE1E6 !important",
    background: "#FFF !important",
    "&:hover": {
      background: "#dedede !important",
    },
  },
}));
